import loadable from '@loadable/component';
import { useState } from 'react';
import { toast } from 'react-toastify';
import APIS from '../../constant/EndPoint';
import usePostHook from '../../customHooks/usePostHook';
import { postApiFormData } from '../../helpers/AxiosInstance';
import CreateIcon from '../../Icons/CreateIcon';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import { useNavigate } from 'react-router-dom';

const OrderBulkUploadComponent = loadable(
  () => import('../../components/Consignment/OrderBulkUpload')
);
const OrderBulkUpload = () => {
  const navigate = useNavigate();
  const [validOrders, setValidOrders] = useState<any>(null);
  const [inValidOrders, setInValidOrders] = useState<any>([]);
  const [openPreviewData, setOpenPreviewData] = useState<Boolean>(false);
  const [isUploading, setIsUploading] = useState<Boolean>(false);

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ['orders'],
    navigateURL: '/',
  });

  const goToCreateOrder = () => {};
  const handleFileUpload = async (data: any, setError: any) => {
    setIsUploading(true);
    const formData = new FormData();
    formData.append('file', data?.file[0]);
    const url = `${APIS.ORDER}daraz-bulk-upload/`;
    try {
      const res = await postApiFormData({ url, formData, setError: () => {} });
      if (res?.status === 200) {
        // setValidOrders(res?.data);
        const validOrders = res?.data;
        navigate('/create', { state: { validOrders } });
      }
    } catch (e) {
      toast.error('Somethings went wrongs');
    }
    setIsUploading(false);
  };

  const handleCommitValidOrders = async () => {
    const url = `${APIS.ORDER}commit-bulk-upload/`;
    let formData = {
      valid_order: validOrders,
    };
    try {
      const res = await mutateAsync({ url, formData });
      if (res.status === 200) {
        setOpenPreviewData(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />

        <span className='text-[#5E5757] font-bold text-xl'>
          Bulk Order Upload
        </span>
      </div>
      <OrderBulkUploadComponent
        handleFileUpload={handleFileUpload}
        validOrders={validOrders}
        inValidOrders={inValidOrders}
        openPreviewData={openPreviewData}
        setOpenPreviewData={setOpenPreviewData}
        handleCommitValidOrders={handleCommitValidOrders}
        isUploading={isPostLoading}
        isFileUploading={isUploading}
      />
    </>
  );
};

export default OrderBulkUpload;
